<template>
  <div class="face-container">
    <div class="face-box">
      <div class="img-box"></div>
      <div class="text-box">
        <p>当前人脸信息未采集，</p>
        <p>请到当地社区进行人工验证。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.face-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  .face-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 221px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    color: #444545;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
  }
  .img-box {
    width: 70px;
    height: 66px;
    background: url("../../assets/img_null.png") no-repeat center;
    background-size: 70px 66px;
    overflow: hidden;
    margin-bottom: 25px;
  }
  .text-box {
    font-family: PingFang SC;
    font-weight: 400;
    color: #444545;
    line-height: 27px;
    p{
      text-align: center;
    }
  }
}
</style>